import React, { useState } from 'react';
import ButtonOptions from '../../../../../../../../components/NovoSistema/ButtonOptions';
import ButtonsGeneric from '../../../../../../../../components/NovoSistema/ButtonsGeneric';
import { ContainerSection } from '../../../../../../../../components/NovoSistema/ContainerSection';
import HeaderButtons from '../../../../../../../../components/NovoSistema/HeaderButtons';
import InputText from '../../../../../../../../components/NovoSistema/InputText';
import SelectAndOptions from '../../../../../../../../components/NovoSistema/SelectAndOptions';
import { WrapperInputsNewSystem } from '../../../../../../../../components/NovoSistema/WrapperInputsNewSystem';

export default function LocalizacaoAdd({ setOption }) {
  const [internalOption, setInternalOption] = useState('Principal');
  return (
    <div>
      <HeaderButtons>
        <ButtonOptions
          buttonName="Principal"
          border="#333F50"
          active={internalOption === 'Principal' ? true : false}
          yourFunction={() => setInternalOption('Principal')}
        />
      </HeaderButtons>
      {internalOption === 'Principal' && (
        <div>
          <ContainerSection>
            <div>
              <WrapperInputsNewSystem>
                <SelectAndOptions
                  title="Situação"
                  id="Situacao"
                  optionsArray={['Ativo', 'Inativo']}
                  widthPercentage="45%"
                />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <InputText title="Código" id="Codigo" widthPercentage="45%" disabled={true} />
                <InputText title="* Descrição" id="Discricao" widthPercentage="45%" />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <InputText title="Zona" id="Zona" widthPercentage="45%" />
                <InputText title="Altura(mm)" id="Altura" widthPercentage="45%" />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <InputText title="Rua" id="Rua" widthPercentage="45%" />
                <InputText title="Largura(mm)" id="Largura" widthPercentage="45%" />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <InputText title="Quadra" id="Quadra" widthPercentage="45%" />
                <InputText title="Profundidade(mm)" id="Profundidade" widthPercentage="45%" />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <InputText title="Prateleira" id="Prateleira" widthPercentage="45%" />
                <InputText title="Volume Max/em M3" id="VolumeMaxM3" widthPercentage="45%" />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <InputText title="Box" id="Box" widthPercentage="45%" />
                <InputText title="Peso Max/Suportado" id="PesoMaxSuportado" widthPercentage="45%" />
              </WrapperInputsNewSystem>
            </div>
          </ContainerSection>
        </div>
      )}
      <ButtonsGeneric>
        <button className="success">Salvar</button>
        <button className="error" onClick={() => setOption('search')}>
          Retornar
        </button>
      </ButtonsGeneric>
      <span> {' * '} Campo de preenchimento Obrigatório</span>
    </div>
  );
}
